import { render, staticRenderFns } from "./Detail-Enquiry.vue?vue&type=template&id=3f2b889f&scoped=true"
import script from "./Detail-Enquiry.vue?vue&type=script&lang=js"
export * from "./Detail-Enquiry.vue?vue&type=script&lang=js"
import style0 from "./Detail-Enquiry.vue?vue&type=style&index=0&id=3f2b889f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b889f",
  null
  
)

export default component.exports